import React, { Component } from 'react';
import Radium from 'radium';

class Error extends Component {

	getErrorString() {
		if (this.props.error.message) {
			return this.props.error.message;
		}

		return "An error occurred";
	}

	render() {
		if (!this.props.error) {
			return null;
		}

		return (
			<div style={this.localStyles().error}>
				{this.getErrorString()}
			</div>
		);
	}

	localStyles() {
		return {
			error: {
				marginTop: 30,
				color: this.props.style.colors.red,
				fontSize: 18,
				fontWeight: "700"
			}
		}
	}
}

export default Radium(Error);


// WEBPACK FOOTER //
// ./src/components/Error.js